import { render, staticRenderFns } from "./ClamRepay.vue?vue&type=template&id=9577bfca&"
import script from "./ClamRepay.vue?vue&type=script&lang=js&"
export * from "./ClamRepay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports